import React, { Component } from 'react';
import { TextField } from '@mui/material';
class TextInput extends Component{
  render(){
    const { input: { ...inputProps }, meta: { touched, error } = {}, ...props }  = this.props;
    return(
      <TextField
            error={!!(touched && error)}
            helperText={touched && error}
            variant="standard"
            {...inputProps}
            {...props}
            fullWidth
      />
    )
  }
}

export default TextInput;
